// Component: ThemeSettings.jsx
// Purpose: "Appearance" settings — theme mode (light/dark) + accent color.
//   A compact DS Modal (was a MUI-based right drawer that didn't follow the
//   theme). Mounted by MainLayout only while `themeSettings` is true.

import React from "react";
import { themeColors } from "../data/staticdata";
import { useStateContext } from "../contexts/ContextProvider";
import { Modal, Icon } from "./ds";

const MODES = [
  { mode: "Light", icon: "sun" },
  { mode: "Dark", icon: "moon" },
];

const ThemeSettings = () => {
  const { setColor, setMode, currentMode, currentColor, setThemeSettings } = useStateContext();

  return (
    <Modal open onClose={() => setThemeSettings(false)} title="Appearance" size="sm">
      {/* Theme mode */}
      <div className="ds-eyebrow mb-3">Theme mode</div>
      <div className="grid grid-cols-2 gap-3 mb-6">
        {MODES.map(({ mode, icon }) => {
          const active = currentMode === mode;
          return (
            <button
              key={mode}
              type="button"
              onClick={() => setMode({ target: { value: mode } })}
              className="relative rounded-lg p-4 flex flex-col items-center gap-2 border transition-colors"
              style={{
                borderColor: active ? currentColor : "var(--divider)",
                background: active ? `color-mix(in srgb, ${currentColor} 8%, transparent)` : "transparent",
              }}
            >
              <span className="p-2.5 rounded-full bg-bg-3 text-fg-2 inline-flex">
                <Icon name={icon} size={20} />
              </span>
              <span className="text-sm font-medium text-fg-1">{mode}</span>
              {active && (
                <span
                  className="absolute -top-2 -right-2 w-5 h-5 rounded-full flex items-center justify-center text-white"
                  style={{ background: currentColor }}
                >
                  <Icon name="success" size={13} />
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Accent color */}
      <div className="ds-eyebrow mb-3 pt-4 border-t border-[var(--divider)]">Accent color</div>
      <div className="flex flex-wrap gap-3">
        {themeColors.map((item) => {
          const active = item.color === currentColor;
          return (
            <button
              key={item.name}
              type="button"
              title={item.name}
              aria-label={item.name}
              onClick={() => setColor(item.color)}
              className="h-9 w-9 rounded-full flex items-center justify-center transition-transform hover:scale-110"
              style={{
                background: item.color,
                boxShadow: active ? `0 0 0 2px var(--bg-2), 0 0 0 4px ${item.color}` : "none",
              }}
            >
              {active && <Icon name="success" size={16} className="text-white" />}
            </button>
          );
        })}
      </div>
    </Modal>
  );
};

export default ThemeSettings;
